import axiosInstance from "../mainService";
const advantageService = {
    getAdvantage(search, page, limit, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m143_advantages/name/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        })
    },
    totalAllAdvantage(company) {
        const sanitizedSearch = 'all';
        return axiosInstance.get(`/count-data/m143_advantages/name/${sanitizedSearch}/${company}`);
    },
    addAdvantage(advantage) {
        return axiosInstance.post('/insert-data/m143_advantages', advantage);
    },
    updateAdvantage(advantage) {
        return axiosInstance.put(`/update-data/m143_advantages/${advantage.id}`, advantage);
    },
    deleteAdvantage(advantageId) {
        return axiosInstance.delete(`/delete-data/m143_advantages/${advantageId}`);
    }
}
export default advantageService;